module.exports = __webpack_public_path__ + "img/splash-image-6.4e1d1e08.png";